{
  "name": "Course study",
  "entry": "Study this course",
  "plan": "Study a course",
  "session": {
    "button": "Study this course today",
    "line": "Uses {golfHours} of today's golf hours. Once a day for each course.",
    "done": "Studied today.",
    "cap": "{golferName} knows this course as well as study can teach. Play it to learn more.",
    "bought": "Extra golf hours teach only the basics of a course. To know it better, study in your own hours or play it."
  }
}
